import PricingAllWrapper from '@/components/pages/pricing-all-wrapper';
import { useParams } from 'react-router-dom';

/**
 * Page that shows all Pricing in a table format.
 * @returns {JSX.Element} The rendered Pricing Management page component.
 */
const CompanyPricingAll = () => {
  const { id } = useParams();

  return <PricingAllWrapper companyId={id} />;
};

export default CompanyPricingAll;
